import { useContext } from "react";

import { TabsContext } from "./TabsContext";

const useTab = (id: string) => {
  const tabs = useContext(TabsContext);
  if (!tabs) {
    console.warn("no tabs");
    return;
  }
  const currentTab = tabs.find((tab) => tab.id === id);
  if (!currentTab) {
    console.warn("no current tab");
    return;
  }
  return currentTab;
};

export default useTab;
